var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.loading)?_c('Loading'):_vm._e(),_c('BaseConfirm',{attrs:{"icon-type":"badge","title":"Hapus Wilayah Harga","message":"Apakah anda yakin ingin menghapus wilayah harga ini?","visible":_vm.visible},on:{"close":function($event){return _vm.$emit('close')},"confirmed":_vm.onConfirm}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }